import { useEffect } from 'react';
import { useCartContext } from '@/providers/CartProvider';
import { IS_PREVIEW } from '@/utils/env';
import {
  pushToElevarDataLayer,
  getUserProperties,
  transformCartItemsToElevar,
  formatPrice,
} from './utils';
import { ElevarUserDataEvent } from './types';

/**
 * Base Elevar event that should be fired on all virtual page changes (including landing page),
 * before any other event. This hook provides essential cart and user context to Elevar.
 */
export const useElevarUserData = () => {
  const { cartItems, getCartTotalPrice } = useCartContext();

  useEffect(() => {
    if (IS_PREVIEW) return;

    const cartTotal = formatPrice(getCartTotalPrice());
    const userProperties = getUserProperties();
    const cartProducts = transformCartItemsToElevar(cartItems);

    const event: ElevarUserDataEvent = {
      event: 'dl_user_data',
      cart_total: cartTotal,
      user_properties: userProperties,
      ecommerce: {
        currencyCode: 'USD',
        cart_contents: {
          products: cartProducts,
        },
      },
    };

    pushToElevarDataLayer(event);
  }, [cartItems, getCartTotalPrice]);
};

export default useElevarUserData;
